import Container from "../../../../../components/components-ui/Container/Container";
import { Modal } from "@mui/material";
import { Table } from "../../../../../components/Table";
import api from "../../../../../services/Api";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ModalContrapartida from "./ModalContrapartida/ModalContrapartida";

// COLUNAS DAS TABELAS
const columns = [
  {
    column: "Nº Coleta",
  },
  {
    column: "Data Pedido",
  },
  {
    column: "Data da Freguesia",
  },
  {
    column: "Item",
  },
  {
    column: "Qtde. Óleo",
  },
  {
    column: "Forma Pagto.",
  },
  {
    column: "Valor Pagto.",
  },
  {
    column: "Média Valor Pago.",
  },
  {
    column: "Freguesia",
  },
  {
    column: "Observação",
  },
];

export default function Coletas() {
  const [apiDadosColeta, setApiDadosColeta] = useState([]);
  const { id } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const [contrapartida, setContrapartida] = useState(false);

  // LINKS
  const API_DADOS_LOCAL = `/local/show/`;
  // CARREGA DADOS DO LOCAL
  useEffect(() => {
    if (id) {
      async function getDadosApiColeta() {
        const response = await api.get(`${API_DADOS_LOCAL}${id}`);
        setApiDadosColeta(response.data.coleta);
      }
      getDadosApiColeta();
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  const onClickVisualizarProdutos = (contrapartida) => {
    console.log('clicou')
    console.log(contrapartida)
    setContrapartida(contrapartida);
    setOpenModal(true);
  };

  return (
    <Container>
      <Table columns={columns}>
        {apiDadosColeta.map((values) => (
          <tr key={values?.id_coleta}>
            <td>{values?.IDColeta}</td>
            <td>{values?.DataPedido}</td>
            <td>{values?.DataFreguesia}</td>
            <td>{values?.Item}</td>
            <td>{values?.QuantidadeOleo}</td>
            <td>
              {values?.["FormaDePagto."]}
              {values?.["FormaDePagto."] == "PRODUTOS" && (
                <i
                  class="fas fa-search"
                  style={{ cursor: "pointer", marginLeft: "8px" }}
                  title="Visualizar"
                  onClick={() =>
                    onClickVisualizarProdutos(values?.coleta_contrapartida)
                  }
                ></i>
              )}
            </td>
            <td>
              {values?.ValorPagamento
                ? parseFloat(values?.ValorPagamento).toFixed(2)
                : null}
            </td>
            <td>
              {values?.MediaVlrPago
                ? parseFloat(values?.MediaVlrPago).toFixed(2)
                : null}
            </td>
            <td>{values?.Freguesia}</td>
            <td>{values?.Observacoes}</td>
          </tr>
        ))}
      </Table>
      {!apiDadosColeta.length && (
        <div style={{ textAlign: "center" }}>Nenhuma coleta para exibir</div>
      )}
      <Modal
        open={openModal}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalContrapartida
          contrapartida={contrapartida}
          closeModal={() => setOpenModal(false)}
        />
      </Modal>
    </Container>
  );
}
